(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gfe-experience-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gfe-experience-library')) {
    customElements.define('gfe-experience-library', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('[data-dialog]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.content = this.querySelector('[data-dialog-content]');
        this.addEventListener('gfe:practice-version', event => {
          const button = event.detail && event.detail.button;
          if (this.session && this.session.hasAttribute('data-version-context') && button instanceof HTMLElement && this.session.contains(button)) this.chooseClip(button);
        }, options);
        this.cards = Array.from(this.querySelectorAll('[data-practice-card]'));
        this.querySelectorAll('a[data-practice-link]').forEach(link => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = link.className;
          button.dataset.practiceId = link.dataset.practiceId;
          button.dataset.practiceLink = '';
          const title = link.querySelector('.gfe-el__card-title').textContent.trim();
          button.setAttribute('aria-label', `${this.dataset.openLabel}：${title}`);
          button.setAttribute('aria-haspopup', 'dialog');
          button.append(...link.childNodes);
          link.replaceWith(button);
        });
        this.querySelector('[data-filters]').hidden = false;
        this.addEventListener('click', event => {
          if (event.target.closest('[data-refresh-retry]')) { this.refreshLibrary(); return; }
          const filter = event.target.closest('[data-filter]');
          if (filter) { this.filter(filter.dataset.filter); return; }
          const opener = event.target.closest('button[data-practice-id]');
          if (opener) { this.openPractice(opener.dataset.practiceId, opener); return; }
          if (event.target.closest('[data-close]')) { this.dialog.close(); return; }
          const clip = event.target.closest('[data-clip]');
          if (clip) { this.chooseClip(clip); return; }
          if (event.target.closest('[data-play]')) this.play();
        }, options);
        this.dialog.addEventListener('pointerdown', event => {
          const rect = this.dialog.getBoundingClientRect();
          this.backdropPress = event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
        }, options);
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
          if (event.target === this.dialog && outside && this.backdropPress) this.dialog.close();
          this.backdropPress = false;
        }, options);
        this.dialog.addEventListener('close', () => this.finishClose(), options);
        this.addEventListener('shopify:block:select', event => {
          const blockId = event.detail && event.detail.blockId;
          const card = this.cards.find(item => item.dataset.blockId === blockId);
          if (card) { this.filter('all'); this.openPractice(blockId, card.querySelector('button[data-practice-id]')); return; }
          for (const item of this.cards) {
            const template = item.querySelector('template');
            const clip = Array.from(template.content.querySelectorAll('[data-clip]')).find(node => node.dataset.blockId === blockId);
            if (clip) {
              this.filter('all');
              this.openPractice(item.dataset.blockId, item.querySelector('button[data-practice-id]'));
              const liveClip = Array.from(this.content.querySelectorAll('[data-clip]')).find(node => node.dataset.blockId === blockId);
              if (liveClip) this.chooseClip(liveClip);
              break;
            }
          }
        }, options);
        this.filter('all');
        this.grid = this.querySelector('.gfe-el__grid');
        try { this.sources = JSON.parse(this.querySelector('[data-library-sources]').textContent); }
        catch (_) { this.sources = null; }
        if (this.dataset.autoDiscover === 'true') {
          this.refreshLibrary();
          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') this.refreshLibrary();
          }, options);
          window.addEventListener('pageshow', event => {
            if (event.persisted) this.refreshLibrary();
          }, options);
        }
      }
      disconnectedCallback() {
        this.stopMedia();
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.finishClose();
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
      filter(category) {
        this.activeFilter = category;
        let count = 0;
        this.cards.forEach(card => {
          card.hidden = category !== 'all' && card.dataset.category !== category;
          if (!card.hidden) count += 1;
        });
        this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
        this.querySelector('[data-empty]').hidden = count > 0;
      }
      openPractice(id, opener) {
        const template = Array.from(this.querySelectorAll('template[data-practice-template]')).find(item => item.dataset.practiceTemplate === id);
        if (!template) return;
        this.stopMedia();
        if (!this.dialog.open) this.savedScroll = { x: window.scrollX, y: window.scrollY };
        this.opener = opener;
        this.content.replaceChildren(template.content.cloneNode(true));
        this.session = this.content.querySelector('[data-session]');
        if (this.session.hasAttribute('data-version-context')) {
          const fullButton = this.session.querySelector('[data-practice-version="full"]');
          if (fullButton) {
            for (const key of ['provider', 'mediaId', 'mediaSource', 'mediaTitle', 'mediaPoster', 'aspect']) this.session.dataset[key] = fullButton.dataset[key] || '';
          }
        }
        this.dialog.setAttribute('aria-labelledby', this.session.querySelector('h2').id);
        this.refreshMediaState();
        this.prepareEmbeddedMedia();
        if (!this.dialog.open) { this.lockScroll(); this.dialog.showModal(); }
        this.dialog.scrollTop = 0;
        this.dialog.querySelector('[data-close]').focus({ preventScroll: true });
      }
      sourceKeys(value) {
        const keys = [];
        if (typeof value.handle === 'string' && value.handle) keys.push(`page:${value.handle.toLowerCase()}`);
        if (typeof value.episodeId === 'string' && value.episodeId) keys.push(`episode:${value.episodeId.toUpperCase()}`);
        const path = this.localGuide(value.url || value.guide);
        if (path) {
          try { keys.push(`page:${decodeURIComponent(path.split('/pages/')[1]).toLowerCase()}`); } catch (_) {}
        }
        return Array.from(new Set(keys));
      }
      localGuide(value) {
        if (typeof value !== 'string' || !value) return '';
        try {
          const url = new URL(value, window.location.origin);
          if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/[^/]+\/?$/i.test(url.pathname)) return '';
          const prefix = window.location.pathname.split('/pages/')[0];
          return `${prefix}/pages/${url.pathname.split('/pages/')[1].replace(/\/$/, '')}`;
        } catch (_) { return ''; }
      }
      publicMedia(value) {
        if (typeof value !== 'string' || !value) return '';
        try {
          const url = new URL(value, window.location.origin);
          return url.protocol === 'https:' ? url.href : '';
        } catch (_) { return ''; }
      }
      episodeHostedMedia(value) {
        if (typeof value !== 'string' || !value.startsWith('https://cdn.shopify.com/')) return '';
        try {
          const url = new URL(value);
          return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' && !url.port && !url.username && !url.password && /\.mp4$/i.test(url.pathname) ? url.href : '';
        } catch (_) { return ''; }
      }
      normalizeRecord(raw) {
        if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
        const url = this.localGuide(raw.url);
        const publishedAt = Number(raw.publishedAt);
        if (!url || typeof raw.handle !== 'string' || !raw.handle || typeof raw.episodeId !== 'string' || !raw.episodeId || typeof raw.title !== 'string' || !raw.title.trim()) return null;
        if (!Number.isFinite(publishedAt) || publishedAt <= 0 || publishedAt > Date.now() / 1000) return null;
        const hosted = this.episodeHostedMedia(raw.mediaSource);
        if (raw.mediaSource) {
          if (raw.provider !== 'hosted' || !hosted) return null;
        } else if (raw.provider !== 'youtube' || !/^[a-zA-Z0-9_-]{11}$/.test(raw.mediaId || '')) return null;
        if (!Array.isArray(raw.preparation) || !raw.preparation.some(line => typeof line === 'string' && line.trim()) || !(this.publicMedia(raw.cover) || this.publicMedia(raw.poster))) return null;
        const allowedVisibility = [null, undefined, '', 'public', 'library', 'visible'];
        return {
          ...raw, url, publishedAt, title: raw.title.trim(),
          visibilityAllowed: allowedVisibility.includes(raw.visibility),
          description: typeof raw.description === 'string' ? raw.description : '',
          meta: typeof raw.meta === 'string' ? raw.meta : '',
          preparation: Array.isArray(raw.preparation) ? raw.preparation.filter(line => typeof line === 'string' && line.trim()) : [],
          cover: this.publicMedia(raw.cover), poster: this.publicMedia(raw.poster),
          category: 'daily', aspect: raw.aspect === 'landscape' ? 'landscape' : 'portrait', mediaSource: hosted, mediaId: hosted ? '' : raw.mediaId
        };
      }
      async refreshLibrary() {
        if (this.refreshing || this.dataset.autoDiscover !== 'true') return;
        if (!Array.isArray(this.sources)) { this.querySelector('[data-refresh-error]').hidden = false; return; }
        this.refreshing = true;
        this.querySelector('[data-refresh-error]').hidden = true;
        const controller = new AbortController();
        const abort = () => controller.abort();
        const componentSignal = this.controller.signal;
        componentSignal.addEventListener('abort', abort, { once: true });
        const timeout = window.setTimeout(abort, 18000);
        try {
          const base = new URL(window.location.href);
          base.search = '';
          base.hash = '';
          base.searchParams.set('view', 'gfe-experience-feed');
          const preview = new URL(window.location.href).searchParams.get('preview_theme_id') || this.dataset.previewThemeId;
          if (preview) base.searchParams.set('preview_theme_id', preview);
          const read = async (number, param = 'page') => {
            const url = new URL(base);
            url.searchParams.set(param, String(number));
            const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'text/html' } });
            if (!response.ok) throw new Error('Feed request failed');
            const text = await response.text();
            if (text.length > 500000) throw new Error('Feed exceeds expected size');
            const feed = JSON.parse(text);
            if (feed.version !== 1 || feed.page !== number || !Number.isInteger(feed.pages) || feed.pages < 1 || feed.pages > 500 || !Array.isArray(feed.records) || feed.records.length > 50 || typeof feed.pageParam !== 'string' || !/^page(?:_[a-zA-Z0-9]+)?$/.test(feed.pageParam)) throw new Error('Invalid feed');
            return feed;
          };
          const first = await read(1);
          const pages = [first];
          for (let number = 2; number <= first.pages; number += 3) {
            const batch = [];
            for (let next = number; next < number + 3 && next <= first.pages; next += 1) batch.push(read(next, first.pageParam));
            pages.push(...await Promise.all(batch));
          }
          if (pages.some(page => page.pages !== first.pages || page.pageParam !== first.pageParam)) throw new Error('Feed changed during refresh');
          const records = pages.flatMap(page => page.records).map(raw => this.normalizeRecord(raw)).filter(Boolean);
          if (!this.isConnected || controller.signal.aborted) return;
          if (this.dialog.open) this.pendingRecords = records;
          else this.reconcileLibrary(records);
        } catch (_) {
          if (this.isConnected && !componentSignal.aborted) this.querySelector('[data-refresh-error]').hidden = false;
        } finally {
          window.clearTimeout(timeout);
          componentSignal.removeEventListener('abort', abort);
          this.refreshing = false;
        }
      }
      reconcileLibrary(records) {
        const originals = this.cards.filter(card => card.dataset.sourceLinked !== 'true' && !card.hasAttribute('data-auto-card'));
        const existingById = new Map(this.cards.map(card => [card.dataset.blockId, card]));
        const blockedKeys = new Set(this.sources.filter(source => !source.enabled).flatMap(source => this.sourceKeys(source)));
        const usedKeys = new Set();
        const nextCards = [];
        const sorted = records.slice().sort((a, b) => b.publishedAt - a.publishedAt || a.handle.localeCompare(b.handle));
        for (const record of sorted) {
          const keys = this.sourceKeys(record);
          if (keys.some(key => blockedKeys.has(key) || usedKeys.has(key))) continue;
          const source = this.sources.find(item => item.enabled && this.sourceKeys(item).some(key => keys.includes(key)));
          if (!record.visibilityAllowed && !(source && source.linked && source.include)) continue;
          keys.forEach(key => usedKeys.add(key));
          if (source && !source.linked) {
            const card = existingById.get(source.blockId);
            if (card) nextCards.push(card);
            continue;
          }
          const merged = { ...record };
          if (source) {
            for (const [key, value] of Object.entries(source.overrides || {})) {
              if (typeof value === 'string' && value.trim()) merged[key] = value;
            }
            if (typeof merged.preparation === 'string') merged.preparation = merged.preparation.split(/\r?\n/).filter(line => line.trim());
            merged.url = this.localGuide(merged.url) || record.url;
            merged.cover = this.publicMedia(merged.cover);
            merged.poster = this.publicMedia(merged.poster);
            merged.mediaSource = this.publicMedia(merged.mediaSource);
            const mediaOverrides = source.overrides || {};
            if (typeof mediaOverrides.mediaSource === 'string' && mediaOverrides.mediaSource.trim()) {
              merged.provider = 'hosted';
              merged.mediaId = '';
            } else if (typeof mediaOverrides.mediaId === 'string' && mediaOverrides.mediaId.trim()) {
              merged.mediaSource = '';
            }
            merged.category = ['daily', 'relax', 'kits'].includes(merged.category) ? merged.category : 'daily';
          }
          const card = this.createEpisodeCard(merged, source);
          const previous = source && existingById.get(source.blockId);
          if (previous && previous.hasAttribute('data-shopify-editor-block')) card.setAttribute('data-shopify-editor-block', previous.getAttribute('data-shopify-editor-block'));
          nextCards.push(card);
        }
        for (const card of originals) if (!nextCards.includes(card)) nextCards.push(card);
        nextCards.sort((a, b) => (Number(b.dataset.publishedAt) || 0) - (Number(a.dataset.publishedAt) || 0));
        const focused = document.activeElement && document.activeElement.closest('[data-practice-card]');
        const focusedId = focused && focused.dataset.blockId;
        this.grid.replaceChildren(...nextCards);
        this.cards = nextCards;
        this.filter(this.activeFilter || 'all');
        if (focusedId) {
          const replacement = this.cards.find(card => card.dataset.blockId === focusedId);
          if (replacement) replacement.querySelector('[data-practice-link]').focus({ preventScroll: true });
        }
      }
      createEpisodeCard(record, source) {
        const fragment = this.querySelector('[data-auto-card-skeleton]').content.cloneNode(true);
        const card = fragment.querySelector('[data-practice-card]');
        const id = source ? source.blockId : `episode-${record.handle}`;
        card.dataset.blockId = id;
        card.dataset.sourceLinked = source ? 'true' : 'false';
        card.dataset.sourceHandle = record.handle;
        card.dataset.episodeId = record.episodeId;
        card.dataset.publishedAt = String(record.publishedAt);
        card.dataset.category = record.category;
        const fill = (root, selector, value) => {
          const node = root.querySelector(selector);
          node.textContent = value || '';
          node.hidden = !value;
        };
        const image = (root, selector, value) => {
          const node = root.querySelector(selector);
          if (value) node.src = value;
          else node.remove();
        };
        const opener = card.querySelector('[data-practice-link]');
        opener.dataset.practiceId = id;
        opener.setAttribute('aria-label', `${this.dataset.openLabel}：${record.title}`);
        fill(card, '.gfe-el__card-title', record.title);
        fill(card, '.gfe-el__card-description', record.description);
        fill(card, '.gfe-el__card-meta', record.meta);
        image(card, '.gfe-el__cover > img', record.cover);
        const template = card.querySelector('template');
        template.dataset.practiceTemplate = id;
        const session = template.content.querySelector('[data-session]');
        for (const [key, value] of Object.entries({ aspect: record.aspect, provider: record.provider, mediaId: record.mediaId, mediaSource: record.mediaSource, mediaTitle: record.title, mediaPoster: record.poster })) session.dataset[key] = value || '';
        const category = this.querySelector(`[data-filter="${record.category}"]`);
        fill(session, '.gfe-el__category', category ? category.textContent : '');
        fill(session, 'h2', record.title);
        session.querySelector('h2').id = `ExperienceDialogTitle-${this.dataset.sectionId}-${id}`;
        fill(session, '.gfe-el__session-meta', record.meta);
        fill(session, '.gfe-el__session-description', record.description);
        const preparation = session.querySelector('.gfe-el__preparation');
        preparation.hidden = !record.preparation.length;
        const headingId = `ExperiencePreparation-${this.dataset.sectionId}-${id}`;
        preparation.querySelector('h3').id = headingId;
        preparation.setAttribute('aria-labelledby', headingId);
        for (const line of record.preparation) {
          const item = document.createElement('li');
          item.textContent = line;
          preparation.querySelector('ol').append(item);
        }
        session.querySelector('[data-play]').setAttribute('aria-label', `${this.dataset.playLabel}：${record.title}`);
        image(session, '[data-play] img', record.poster || record.cover);
        session.querySelector('.gfe-el__guide a').href = record.url;
        return card;
      }
      mediaFor(element) {
        if (!element) return null;
        const source = element.dataset.mediaSource;
        if (source) {
          try {
            const url = new URL(source, window.location.origin);
            if (url.protocol === 'https:' || url.protocol === 'http:') return { type: 'hosted', url: url.href };
          } catch (_) { return null; }
          return null;
        }
        const provider = element.dataset.provider;
        const id = element.dataset.mediaId;
        if (provider === 'youtube' && /^[a-zA-Z0-9_-]{6,20}$/.test(id || '')) return { type: provider, id };
        if (provider === 'vimeo' && /^\d+$/.test(id || '')) return { type: provider, id };
        return null;
      }
      refreshMediaState() {
        const available = Boolean(this.mediaFor(this.session));
        this.session.querySelector('[data-play]').hidden = !available;
        this.session.querySelector('[data-media-unavailable]').hidden = available;
        this.session.querySelector('.gfe-el__ready').hidden = !available;
      }
      chooseClip(button) {
        this.stopMedia();
        for (const key of ['provider', 'mediaId', 'mediaSource', 'mediaTitle', 'mediaPoster', 'aspect']) this.session.dataset[key] = button.dataset[key] || '';
        this.session.querySelectorAll('[data-clip]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        const play = this.session.querySelector('[data-play]');
        play.setAttribute('aria-label', `${this.dataset.playLabel}：${button.dataset.mediaTitle}`);
        this.session.querySelector('[data-media-frame]').style.removeProperty('--gfe-el-media-ratio');
        let poster = play.querySelector('img');
        if (this.session.dataset.mediaPoster) {
          if (!poster) { poster = document.createElement('img'); poster.alt = ''; poster.width = 900; poster.height = 1600; play.prepend(poster); }
          poster.src = this.session.dataset.mediaPoster;
        } else if (poster) { poster.remove(); }
        this.refreshMediaState();
        this.prepareEmbeddedMedia();
      }
      prepareEmbeddedMedia() {
        const media = this.mediaFor(this.session);
        if (!media || media.type === 'hosted') return;
        const player = document.createElement('iframe');
        player.src = media.type === 'youtube' ? `https://www.youtube-nocookie.com/embed/${media.id}?autoplay=0&rel=0&playsinline=1` : `https://player.vimeo.com/video/${media.id}?autoplay=0&dnt=1`;
        player.title = this.session.dataset.mediaTitle;
        player.allow = 'encrypted-media; fullscreen; picture-in-picture';
        player.allowFullscreen = true;
        player.referrerPolicy = 'strict-origin-when-cross-origin';
        this.session.querySelector('[data-player]').replaceChildren(player);
        this.session.querySelector('[data-play]').hidden = true;
      }
      play() {
        if (!this.session) return;
        const media = this.mediaFor(this.session);
        if (!media) { this.refreshMediaState(); return; }
        if (media.type !== 'hosted') { this.prepareEmbeddedMedia(); return; }
        this.stopMedia();
        const mount = this.session.querySelector('[data-player]');
        const title = this.session.dataset.mediaTitle;
        let player;
        if (media.type === 'hosted') {
          player = document.createElement('video');
          player.src = media.url;
          player.controls = true;
          player.playsInline = true;
          player.preload = 'none';
          player.addEventListener('loadedmetadata', () => {
            if (!this.session || !player.isConnected || !player.videoWidth || !player.videoHeight) return;
            const ratio = player.videoWidth / player.videoHeight;
            this.session.dataset.aspect = ratio >= 1 ? 'landscape' : 'portrait';
            this.session.querySelector('[data-media-frame]').style.setProperty('--gfe-el-media-ratio', String(ratio));
          }, { once: true });
          player.setAttribute('aria-label', title);
          const poster = this.session.querySelector('[data-play] img');
          if (poster) player.poster = poster.src;
        }
        mount.replaceChildren(player);
        this.session.querySelector('[data-play]').hidden = true;
        player.focus({ preventScroll: true });
        if (media.type === 'hosted') {
          const started = player.play();
          if (started && typeof started.catch === 'function') started.catch(() => {});
        }
      }
      stopMedia() {
        if (!this.content) return;
        this.content.querySelectorAll('video').forEach(video => { video.pause(); video.removeAttribute('src'); video.load(); });
        this.content.querySelectorAll('[data-player]').forEach(mount => mount.replaceChildren());
      }
      lockScroll() {
        if (this.scrollLocked) return;
        const manager = this.constructor;
        if (!manager.scrollLocks) manager.scrollLocks = new Set();
        if (manager.scrollLocks.size === 0) {
          const body = document.body;
          const root = document.documentElement;
          const properties = ['position', 'top', 'left', 'width', 'overflow', 'padding-right'];
          const scrollbar = window.innerWidth - root.clientWidth;
          const padding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
          manager.scrollSnapshot = {
            x: window.scrollX, y: window.scrollY,
            body: properties.map(name => [name, body.style.getPropertyValue(name), body.style.getPropertyPriority(name)]),
            root: [root.style.getPropertyValue('overflow'), root.style.getPropertyPriority('overflow')]
          };
          body.style.setProperty('position', 'fixed');
          body.style.setProperty('top', `${-manager.scrollSnapshot.y}px`);
          body.style.setProperty('left', `${-manager.scrollSnapshot.x}px`);
          body.style.setProperty('width', '100%');
          body.style.setProperty('overflow', 'hidden');
          if (scrollbar > 0) body.style.setProperty('padding-right', `${padding + scrollbar}px`);
          root.style.setProperty('overflow', 'hidden');
        }
        manager.scrollLocks.add(this);
        this.scrollLocked = true;
      }
      unlockScroll() {
        if (!this.scrollLocked) return;
        const manager = this.constructor;
        manager.scrollLocks.delete(this);
        this.scrollLocked = false;
        if (manager.scrollLocks.size > 0) return;
        const saved = manager.scrollSnapshot;
        saved.body.forEach(([name, value, priority]) => {
          if (value) document.body.style.setProperty(name, value, priority);
          else document.body.style.removeProperty(name);
        });
        if (saved.root[0]) document.documentElement.style.setProperty('overflow', saved.root[0], saved.root[1]);
        else document.documentElement.style.removeProperty('overflow');
        window.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' });
        manager.scrollSnapshot = null;
      }
      finishClose() {
        this.stopMedia();
        this.unlockScroll();
        if (this.content) this.content.replaceChildren();
        this.session = null;
        if (this.isConnected) {
          if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
          if (this.savedScroll && (window.scrollX !== this.savedScroll.x || window.scrollY !== this.savedScroll.y)) window.scrollTo({ left: this.savedScroll.x, top: this.savedScroll.y, behavior: 'instant' });
        }
        this.opener = null;
        this.savedScroll = null;
        if (this.pendingRecords && this.isConnected) {
          const records = this.pendingRecords;
          this.pendingRecords = null;
          this.reconcileLibrary(records);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gfe-latest-story-grid"]) return;
  try {
    
  document.querySelectorAll('[data-gfe-uniform-grid]').forEach(async (section) => {
    if (section.dataset.gfeUniformGridReady === 'true') return;
    section.dataset.gfeUniformGridReady = 'true';
    try {
      const response = await fetch(section.dataset.gfeWePickUrl);
      if (!response.ok) return;
      const payload = await response.json();
      const locale = section.dataset.gfeLocale === 'en' ? 'en' : 'zh';
      section.querySelectorAll('[data-gfe-caption-key]').forEach((card) => {
        const entry = payload.groups?.[card.dataset.gfeCaptionKey];
        const longCaption = entry?.[locale]?.split(/\n\s*\n/)[0]?.trim();
        const caption = entry?.short?.[locale]?.trim() || longCaption;
        if (!caption) return;
        const why = card.querySelector('[data-gfe-why]');
        const copy = card.querySelector('[data-gfe-why-copy]');
        if (copy) copy.textContent = caption;
        if (why) why.hidden = false;
      });
    } catch (error) {
      return;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
